import React, { useEffect, useRef } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";

import {
  admin_admin,
  admin_bp,
  admin_cse,
  admin_csm,
  provider_behavioral,
  provider_pcp,
  provider_prescribe,
  provider_case_manager,
  provider_peer,
  system_workflow,
  user_patient,
} from "@/config/roles";
import { AdminCSMRouter } from "@/portals/(admin)/AdminCSMRouter";
import { AdminRouter } from "@/portals/(admin)/AdminRouter";
import PatientRouter from "@/portals/(patient)/PatientRouter";
import { ProviderRouter } from "@/portals/(provider)/ProviderRouter";

import WorkflowRouter from "./Workflow/WorkflowRouter";

import "./DashboardRouter.styles.scss";

export function DashboardRouter({ role }) {
  const location = useLocation();
  const match = useRouteMatch();
  const prevPathnameRef = useRef(location.pathname);

  useEffect(() => {
    if (prevPathnameRef.current !== "/app/schedule" && location.pathname === "/app/schedule") {
      window.scrollTo(0, 0);
    }
    prevPathnameRef.current = location.pathname;
  }, [location.pathname]);

  let component;

  /* oxlint-disable */
  switch (role) {
    case admin_admin:
    case admin_bp:
    case admin_cse:
      component = <AdminRouter url={match.url} />;
      break;

    case admin_csm:
      component = <AdminCSMRouter url={match.url} />;
      break;

    case user_patient:
      component = <PatientRouter url={match.url} />;
      break;

    case provider_pcp:
    case provider_behavioral:
    case provider_prescribe:
    case provider_case_manager:
    case provider_peer:
      component = <ProviderRouter url={match.url} />;
      break;

    case system_workflow:
      component = <WorkflowRouter url={match.url} />;
      break;

    default:
      component = <PatientRouter url={match.url} />;
  }
  /* oxlint-enable */

  return (
    <div className="tw:flex tw:min-h-screen tw:flex-col tw:not-print:bg-layer-floor-0">
      {component}
    </div>
  );
}
